// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell__2T0HJ","cell_1":"cell_1__1pO1W","cell_2":"cell_2__1H3po"};